import {useSuspenseQuery} from "@tanstack/react-query";
import {useMemo} from "react";
import {secretApi} from "../../../api/api";
import _ from "lodash";

export const useSliMatchApi = ({teamId,team}) => {
    const query = useSuspenseQuery(
        {
            queryKey: ['useSliMatchApi', teamId],
            queryFn: async () => {
                const match = await sll_match_api({teamId,team})
                console.log(match)
                return match
            },
            staleTime:Infinity
        })


    const list = useMemo(() => {
        if (!query?.data) {
            return {team_match_data: [], team_match_up_data: [], matches: [],mercenary:[]}
        }
        return query.data
    }, [query.data])

    return {query, list};
}





const sll_match_api = async ({teamId,team}) => {
    try {
        // const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_first_player`);
        const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_match_data`);
        url.searchParams.set('team_id', teamId)
        const result = await secretApi.get(url.toString());
        const team_match_data = Object.values(result.data.team_match_data);
        const team_match_up_data = Object.entries(result.data.team_match_up_data);

        const reducedMatch = team_match_up_data.reduce((sum, cur) => {
            cur[1].team_name = cur[0]
            sum.push(cur[1])
            return sum
        }, []);

        const matchIds = team_match_data.reduce((sum, cur) => {
            return [...sum, ...cur.match_ids]
        }, [])

        const uniqMatches = _.uniq(matchIds)

        //
        // const addWinLose = team_match_data.map((data) => {
        //     let win = 0;
        //     let lose = 0;
        //     let puu_id = '';
        //     let riot_id_name = ''
        //     let riot_id_tag_line = ''
        //
        //     data.match_ids.forEach((item) => {
        //         const matchIndex = matches.findIndex((match) => match.match_basic_dict.match_id === item);
        //         if (matchIndex > -1) {
        //             const match = matches[matchIndex]
        //             const me = match.participants_list.find((summoner) => summoner.pro_streamer_name === data.name);
        //             if(!me) {
        //                 return;
        //             }
        //             if (!puu_id) {
        //                 puu_id = me.puu_id
        //             }
        //             if(!riot_id_name) {
        //                 riot_id_name = me.riot_id_name
        //             }
        //             if(!riot_id_tag_line) {
        //                 riot_id_tag_line = me.riot_id_tag_line
        //             }
        //             if (me.is_win) {
        //                 win++
        //             } else {
        //                 lose++
        //             }
        //         }
        //     })
        //
        //     return {
        //         ...data,
        //         win, lose,
        //         puu_id,
        //         riot_id_name,
        //         riot_id_tag_line
        //     }
        // })

        const nameList = team.players.map((data) => data.name);
        const onlyPlayers = team_match_data.filter((data) => nameList.includes(data.name))
        const mercenary = team_match_data.filter((data) => !nameList.includes(data.name))

        result.data.mercenary = mercenary
        result.data.team_match_data = onlyPlayers
        result.data.team_match_up_data = reducedMatch
        result.data.matches = uniqMatches

        console.log(result.data)
        return result.data
    } catch (e) {
        console.log(e)
        return {
            mercenary:[],
            team_match_data:[],
            team_match_up_data:[],
            matches:[]
        }
    }
}